import React, { useState, useEffect } from 'react';
import { getDecodedToken } from 'utils/tokenUtils';
import './SessionTimeoutWarning.css';

const SessionTimeoutWarning = ({ onLogout, onExtend }) => {
  const [showWarning, setShowWarning] = useState(false);
  const [timeLeft, setTimeLeft] = useState(0);

  useEffect(() => {
    const checkSessionTimeout = () => {
      const decoded = getDecodedToken();
      if (!decoded) return;

      const currentTime = Date.now() / 1000;
      const timeUntilExpiry = decoded.exp - currentTime;
      const fiveMinutes = 5 * 60; // 5 minutes in seconds

      if (timeUntilExpiry <= 0) {
        // Token already expired — log out immediately
        setShowWarning(false);
        onLogout();
      } else if (timeUntilExpiry <= fiveMinutes) {
        setShowWarning(true);
        setTimeLeft(Math.ceil(timeUntilExpiry));
      } else {
        setShowWarning(false);
      }
    };

    // Check immediately
    checkSessionTimeout();

    // Check every 30 seconds
    const interval = setInterval(checkSessionTimeout, 30000);

    // Update countdown every second when warning is shown
    const countdownInterval = setInterval(() => {
      if (showWarning) {
        setTimeLeft(prev => {
          if (prev <= 1) {
            setShowWarning(false);
            onLogout();
            return 0;
          }
          return prev - 1;
        });
      }
    }, 1000);

    return () => {
      clearInterval(interval);
      clearInterval(countdownInterval);
    };
  }, [showWarning, onLogout]);

  const handleExtend = () => {
    setShowWarning(false);
    onExtend();
  };

  const handleLogout = () => {
    setShowWarning(false);
    onLogout();
  };

  if (!showWarning) return null;

  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;

  return (
    <div className="session-timeout-overlay">
      <div className="session-timeout-modal">
        <div className="session-timeout-header">
          <h3>Session Expiring Soon</h3>
        </div>
        <div className="session-timeout-content">
          <p>Your session will expire in {minutes}:{seconds.toString().padStart(2, '0')}</p>
          <p>Would you like to extend your session or log out?</p>
        </div>
        <div className="session-timeout-actions">
          <button onClick={handleExtend} className="session-timeout-extend">
            Extend Session
          </button>
          <button onClick={handleLogout} className="session-timeout-logout">
            Log Out
          </button>
        </div>
      </div>
    </div>
  );
};

export default SessionTimeoutWarning;
